import React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Layout from '../components/layout';


const StyledMainContainer = styled.main`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  margin-top: 100px;
`;
const StyledTitle = styled.h1`
  color: #000;
  font-family: var(--title-font);
  font-size: clamp(100px, 25vw, 200px);
  line-height: 1;
`;
const StyledSubtitle = styled.h2`
	font-family: var(--title-font);
  font-size: clamp(30px, 5vw, 50px);
  font-weight: 400;
`;
const StyledHomeButton = styled(Link)`
  	color: #FFF;
    background-color: var(--themeColor);
    border: 1px solid var(--themeColor);
    padding: 1.25rem 1.75rem;
    font-size: var(--fz-sm);
    font-family: var(--body-font);
    line-height: 1;
    -webkit-text-decoration: none;
    text-decoration: none;
    cursor: pointer;
    margin-top: 40px;
    
    &:hover{
    	background-color: #000;
    	color: #fff;
    	border: 1px solid #000;
    	-webkit-transition: var(--transition);
    	transition: var(--transition);
    }
`;

const NotFoundPage = ({ location }) => {
  
  return (
    <Layout location={location}>
      <Helmet title="Page Not Found" location={location}/>

      <StyledMainContainer className="fillHeight">
      <StyledTitle>404</StyledTitle>
      <StyledSubtitle>Page Not Found</StyledSubtitle>
      <StyledHomeButton to="/">Go Home</StyledHomeButton>
    </StyledMainContainer>
    </Layout>
  );
};

NotFoundPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default NotFoundPage;
